(function () {
  function formatMoney(cents, moneyFormat) {
    // Very small, reliable formatter for Shopify money formats
    const value = (cents / 100).toFixed(2);
    const parts = value.split(".");
    const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Handle common Shopify formats
    // Examples: "${{amount}}", "{{amount}} USD", "€{{amount_with_comma_separator}}"
    if (moneyFormat.includes("amount_with_comma_separator")) {
      const comma = (cents / 100).toFixed(2).replace(".", ",");
      return moneyFormat.replace("{{amount_with_comma_separator}}", comma);
    }
    if (moneyFormat.includes("amount_no_decimals")) {
      const noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return moneyFormat.replace("{{amount_no_decimals}}", noDecimals);
    }
    return moneyFormat.replace("{{amount}}", withCommas + "." + parts[1]);
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    const bar = document.getElementById("StickyATC");
    if (!bar) return;

    document.body.classList.add("has-sticky-atc");

    const formId = bar.getAttribute("data-form-id");
    const product = JSON.parse(bar.getAttribute("data-product") || "{}");
    const moneyFormat = JSON.parse(bar.getAttribute("data-money-format") || '"{{amount}}"');

    const mainForm = document.getElementById(formId);
    if (!mainForm) return;

    const priceEl = document.getElementById("StickyATCPrice");
    const statusEl = document.getElementById("StickyATCStatus");
    const btn = document.getElementById("StickyATCButton");
    const img = bar.querySelector(".sticky-atc__img");

    const mainSubmit =
      mainForm.querySelector('button[name="add"], button[type="submit"]') ||
      document.querySelector(`#${CSS.escape(formId)} button[type="submit"]`);

    // Variant id input in Dawn product form
    const variantIdInput = mainForm.querySelector('input[name="id"]');

    function getVariantById(id) {
      if (!product || !product.variants) return null;
      const numericId = Number(id);
      return product.variants.find(v => Number(v.id) === numericId) || null;
    }

    function setUIFromVariant(variant) {
      if (!variant) return;

      // Price
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);

      // Availability
      const available = !!variant.available;
      btn.disabled = !available;

      if (statusEl) {
        statusEl.textContent = available ? "" : "Sold out";
      }

      // Image (best-effort)
      // product.variants may have featured_image in some stores; otherwise fall back to product.featured_image
      const vImg =
        (variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) ||
        (product.featured_image) ||
        null;

      if (img && vImg) {
        // Ensure it's a valid URL string
        img.src = vImg;
      }
    }

    function syncFromMainForm() {
      const id = variantIdInput ? variantIdInput.value : null;
      if (!id) return;

      const variant = getVariantById(id);
      if (variant) setUIFromVariant(variant);
    }

    // Show/hide bar when main ATC scrolls out of view
    function setupVisibilityObserver() {
      const target = mainSubmit || mainForm;

      const io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const shouldShow = !entry.isIntersecting && window.scrollY > 150;
          bar.classList.toggle("is-visible", shouldShow);
          bar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        },
        { threshold: 0.05 }
      );

      io.observe(target);
    }

    // Clicking sticky button triggers Dawn’s existing add-to-cart
    btn.addEventListener("click", function () {
      // Make sure UI is synced first
      syncFromMainForm();

      if (mainSubmit) {
        mainSubmit.click();
        return;
      }

      // Fallback: submit form (may not open cart drawer in some setups)
      try {
        mainForm.requestSubmit();
      } catch (e) {
        mainForm.submit();
      }
    });

    // Keep sticky bar updated when variants/options change
    mainForm.addEventListener("change", function () {
      // Dawn updates the hidden input[name="id"] when options change
      // Let it update first (microtask)
      setTimeout(syncFromMainForm, 0);
    });

    // Initial sync
    syncFromMainForm();
    setupVisibilityObserver();
  });
})();
